import { render, staticRenderFns } from "./ConfiguracaoAnoAvaliativo.vue?vue&type=template&id=2f03e7bb&scoped=true&"
import script from "./ConfiguracaoAnoAvaliativo.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoAnoAvaliativo.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoAnoAvaliativo.vue?vue&type=style&index=0&id=2f03e7bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03e7bb",
  null
  
)

export default component.exports